import { diffDates, parseDate } from 'rise-ui/utils/date.js';

const parseQpDate = d => parseDate(d, 'url');

/**
 * Converts date range array to single date range if needed.
 * @param dateRange
 * @return {*}
 */
export function qpDateSingle(dateRange) {
  return Array.isArray(dateRange) ? dateRange[0] : dateRange;
}

function qpDateIsUnfilled(date, options = {}) {
  const { skip } = options || {};
  date = qpDateSingle(date);
  const isObj = typeof date === 'object';
  return !date ? true : (isObj ? ['from', 'to'] : [null]).some(key => {
    if (key && skip && key === skip) {
      return false;
    }
    const d = key ? date[key] : date;
    return !d || !parseQpDate(d);
  });
}

export function qpDateRangeIsUnfilled(dateRange, options) {
  return qpDateIsUnfilled(dateRange, options);
}

export function qpDateRangeIsInverted(dateRange) {
  dateRange = qpDateSingle(dateRange);
  let from, to;
  return dateRange && (from = dateRange.from) && (to = dateRange.to)
    && (from = parseQpDate(from))
    && (to = parseQpDate(to))
    && diffDates(to, from) < 0;
}

function getQpDatesFromRanges(availableDateRange, dateRange, options) {
  availableDateRange = qpDateSingle(availableDateRange);
  dateRange = qpDateSingle(dateRange);
  options = options || {};
  const precision = options.precision || 'days';
  const grace = options.grace && ('' + options.grace).trim() === '0' ? 0 : +options.grace || 1;
  let aFrom, aTo, from, to;
  return availableDateRange && dateRange
    && (aFrom = availableDateRange['from']) && (aTo = availableDateRange['to'])
    && (from = dateRange['from']) && (to = dateRange['to'])
    && (aFrom = parseQpDate(aFrom))
    && (aTo = parseQpDate(aTo))
    && (from = parseQpDate(from))
    && (to = parseQpDate(to))
      ? { aFrom, aTo, from, to, precision, grace } : false;
}

function qpDatesOutsideRange(availableDateRange, dateRange, options, both) {
  const dates = getQpDatesFromRanges(availableDateRange, dateRange, options);
  let low = false;
  let high = false;
  return dates && [dates.from, dates.to][both ? 'every' : 'some'](date =>
    diffDates(date, dates.aFrom, dates.precision) < -dates.grace && (low = true)
    || diffDates(date, dates.aTo, dates.precision) > dates.grace - 1 && (high = true)
  ) && low !== high;
}

export function qpDateRangeIsOutsideRange(availableDateRange, dateRange, options) {
  return qpDatesOutsideRange(availableDateRange, dateRange, options, true);
}

export function qpDateRangeIsPartlyOutsideRange(availableDateRange, dateRange, options) {
  const { skip } = options || {};
  if (skip) {
    availableDateRange = qpDateSingle(availableDateRange);
    const dates = qpDateSingle(dateRange);
    if (dates) {
      dateRange = {};
      Object.keys(dates).forEach(key => {
        dateRange[key] = key !== skip ? dates[key] : availableDateRange[key];
      });
    }
  }
  return qpDatesOutsideRange(availableDateRange, dateRange, options, false);
}

export function qpDateRangeIsInvalid(availableDateRange, dateRange) {
  return qpDateRangeIsUnfilled(dateRange)
    || qpDateRangeIsInverted(dateRange)
    || qpDateRangeIsOutsideRange(availableDateRange, dateRange);
}

export function qpDateRangeIsValid(availableDateRange, dateRange) {
  return !qpDateRangeIsInvalid(availableDateRange, dateRange);
}
